import _createForOfIteratorHelper from "/nerv.app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/nerv.app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/nerv.app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import moment from 'moment';
import Daily from '../daily';
import Weekly from '../weekly';
import noNetTip from "../components/NoNetTip";
import { getSleepDayReport, getSleepWeekReport, getSleepMonthReport, getVipFlag, getWatchSettingInfos } from "@/utils/api";
import { Loading } from 'vant';
import { getSnoreInfos } from "../../utils/api";
import { getPackageName } from "../../utils/native";
import { checkVersion } from "../../utils/utils";
export default {
  name: 'sleep',
  components: {
    VanLoading: Loading,
    Daily: Daily,
    Weekly: Weekly,
    noNetTip: noNetTip
  },
  data: function data() {
    return {
      firstLoad: true,
      isloading: true,
      mode: "day",
      year: "",
      month: "",
      day: "",
      week: "",
      weekYear: "",
      weekMonth: '',
      dayRes: [],
      weekRes: {},
      monthRes: {},
      dayPreRes: [],
      weekPreRes: {},
      monthPreRes: {},
      isVip: false,
      noNet: false,
      temp_unit: '',
      snoreDetail: {},
      // 鼾声数据
      isShowSnore: true,
      snoreDetailLoading: false,
      isCopilotApp: false
    };
  },
  watch: {
    '$route': {
      handler: function handler(route, oldRoute) {
        // console.log('睡眠页面route变化====', route, oldRoute)
        if (route.name && !this.firstLoad) {
          this.getDateByRoute(route);
        } //console.log('route变化444', oldRoute.query);


        if (route && route.query && oldRoute && oldRoute.query) {
          if (route.query.token !== oldRoute.query.token || route.query.wwid !== oldRoute.query.wwid) {
            // console.log('用户变化，重新请求vip，皮肤温度单位')
            this.queryIsVip(); // 获取皮肤温度单位

            this.getTempUnit();
          }
        }
      },
      immediate: true
    }
  },
  created: function created() {
    var _this = this;

    // console.log('睡眠页面初始化====')
    this.getDateByRoute(this.$route);
    this.queryIsVip(); // 获取皮肤温度单位

    this.getTempUnit();
    this.firstLoad = false; // 设置年龄之后刷新周报、月报数据

    window.reQuery = function () {
      _this.getDateByRoute(_this.$route);
    }; // 开通vip之后重新请求是否vip


    window.reQueryVip = function () {
      _this.queryIsVip();
    };

    this.getIsCopilotApp();
  },
  methods: {
    getIsCopilotApp: function getIsCopilotApp() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var package_name;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getPackageName();

              case 2:
                package_name = _context.sent;
                _this2.isCopilotApp = process.env.VUE_APP_H5_ENV === 'wear3' && sessionStorage.getItem('isiOS') === 'true' && (!package_name || package_name === 'com.mobvoi.companion.at');

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getTempUnit: function getTempUnit() {
      var _this3 = this;

      getWatchSettingInfos().then(function (res) {
        //console.log("接口获取到的皮肤温度单位设定", res)
        _this3.temp_unit = res; //this.temp_unit = 'celsius'
      }).catch(function (e) {
        //console.log(e)
        _this3.temp_unit = 'celsius';
      });
    },
    // 通过路由获取选中模式和日期
    getDateByRoute: function getDateByRoute(route) {
      var _ref = route.query || {},
          mode = _ref.mode;

      var _ref2 = route.params || {},
          year = _ref2.year,
          month = _ref2.month,
          day = _ref2.day;

      console.log('路由中的年月日参数', year, month, day);

      if (mode) {
        this.mode = mode;
      }

      this.year = year || moment().year();
      this.month = month || moment().month() + 1;
      this.day = day || moment().date();
      this.noNet = false;

      switch (this.mode) {
        case 'day':
          this.queryDayData(this.year, this.month, this.day);
          this.querySnoreData(this.year, this.month, this.day);
          break;

        case 'week':
          this.queryWeekData();
          this.queryPreWeekData();
          break;

        case 'month':
          this.queryMonthData(this.year, this.month);
          this.queryPreMonthData();
          break;

        default:
          break;
      }
    },
    // 第一周星期一为几号
    getFirstMondayOfMonth: function getFirstMondayOfMonth(year, month) {
      var xq = new Date(year, month - 1, 1).getDay(); // 1号周几

      if (xq === 1) return 1;
      xq = xq ? xq : 7;
      return 7 - xq + 2;
    },
    // 获取这天为第几周（周定义为当前月第一个星期一为第一周）
    getWeek: function getWeek(year, month, day) {
      var result = {
        year: year,
        month: month,
        week: 1
      };
      var firstMondayOfMonth = this.getFirstMondayOfMonth(year, month);

      if (day < firstMondayOfMonth) {
        // 为上个月最后一周
        var d = new Date(year, month - 1, 0);
        return this.getWeek(d.getFullYear(), d.getMonth() + 1, d.getDate());
      } else {
        result.week = Math.floor((day - firstMondayOfMonth) / 7) + 1;
      }

      return result;
    },
    querySnoreData: function querySnoreData(year, month, day) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var showUpdateTips, packageName, platform;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // 安卓目前根据包名 + 版本号来判断是否显示；且只有指定的包名能显示，未指定的包名不显示此模块
                // ios目前就一个app使用w3 h5，故只用版本号判断，若后续ios有多个app集成的话，也需要和安卓一样的方式
                showUpdateTips = true;
                _context2.next = 3;
                return getPackageName();

              case 3:
                packageName = _context2.sent;

                if (packageName) {
                  platform = sessionStorage.getItem('isiOS') === 'true' ? 'ios' : 'android'; //1：iOS 2：Android

                  console.log('packageName', packageName);

                  if (packageName === 'com.mobvoi.companion.at') {
                    // iOS：health copilot；android： mobvoi heath
                    showUpdateTips = checkVersion({
                      wear3_android_oversea: '5.0.0',
                      wear3_ios_oversea: '1.7'
                    }, false);
                  } else if (platform === 'android' && packageName === 'com.mobvoi.companion.openaw') {
                    // android： wearcopilot
                    showUpdateTips = checkVersion({
                      wear3_android_oversea: '8.0.3'
                    }, false);
                  } else if (platform === 'ios' && packageName === 'com.mobvoi.public') {
                    // ios：wearcopilot
                    showUpdateTips = checkVersion({
                      wear3_ios_oversea: '1.2.5'
                    }, false);
                  }
                } else {
                  showUpdateTips = checkVersion({
                    wear3_android_oversea: '5.0.0',
                    wear3_ios_oversea: '1.7'
                  }, false);
                }

                console.log('该app对应版本号是否支持显示鼾声监测', !showUpdateTips);
                _this4.isShowSnore = !showUpdateTips;

                if (!showUpdateTips) {
                  _this4.snoreDetailLoading = true;
                  getSnoreInfos({
                    year: year,
                    month: month,
                    day: day
                  }).then(function (res) {
                    if (res && res.snoreList && res.snoreList.length) {
                      var _iterator = _createForOfIteratorHelper(res.snoreList),
                          _step;

                      try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                          var item = _step.value;
                          item.totalTime = item.endSnore - item.startSnore; // console.log('秒数', item.totalTime / 1000)
                        }
                      } catch (err) {
                        _iterator.e(err);
                      } finally {
                        _iterator.f();
                      }
                    }

                    _this4.snoreDetailLoading = false;
                    _this4.snoreDetail = res;
                  }).catch(function (e) {
                    console.log('接口报错', e);
                    _this4.snoreDetailLoading = false;
                    _this4.snoreDetail = {};
                  });
                } else {
                  _this4.snoreDetail = {};
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 请求日报数据
    queryDayData: function queryDayData(year, month, day) {
      var _this5 = this;

      this.isloading = true;
      getSleepDayReport({
        year: year,
        month: month,
        day: day
      }).then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
          var _this5$getWeek, newYear, newMonth, week;

          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(+_this5.year !== +year || +_this5.month !== +month || +_this5.day !== +day)) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  _this5.dayRes = res;

                  _this5.queryPreDayData();

                  _this5$getWeek = _this5.getWeek(+_this5.year, +_this5.month, +_this5.day), newYear = _this5$getWeek.year, newMonth = _this5$getWeek.month, week = _this5$getWeek.week;

                  if (_this5.weekYear !== newYear || _this5.weekMonth !== newMonth || _this5.week !== week) {
                    _this5.weekYear = newYear;
                    _this5.weekMonth = newMonth;
                    _this5.week = week;

                    _this5.queryWeekData();
                  } else {
                    _this5.isloading = false;

                    _this5.$nextTick(function () {
                      _this5.$refs.daily && _this5.$refs.daily.changeRes(_this5.dayRes);
                      _this5.$refs.daily && _this5.$refs.daily.changePreRes(_this5.dayPreRes);
                    });
                  }

                case 6:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (err) {
        _this5.isloading = false; // 接口报错，当天数据置空，防止数据取上一次成功时候的接口，导致显示数据不正确

        _this5.dayRes = [];

        if (err.code === "ECONNABORTED") {
          _this5.noNet = true;
        }
      });
    },
    // 请求前一天的日报数据
    queryPreDayData: function queryPreDayData() {
      var _this6 = this;

      var _ref4 = this.$route.params || {},
          year = _ref4.year,
          month = _ref4.month,
          day = _ref4.day;

      year = year || moment().year();
      month = month || moment().month() + 1;
      day = day || moment().date();
      var currentDate = year + '/' + month + '/' + day;
      var previewDate = moment(currentDate).subtract(1, 'days').format('YYYY-MM-DD');
      var previewYear = moment(previewDate).format('YYYY');
      var previewMonth = moment(previewDate).format('MM');
      var previewDay = moment(previewDate).format('DD'); // console.log('currentDate', currentDate);

      getSleepDayReport({
        year: previewYear,
        month: previewMonth,
        day: previewDay
      }).then(function (res) {
        console.log('前一天日报数据', previewYear, previewMonth, previewDay, res); // 日期切换后，之前请求的数据弃用

        if (_this6.year + '/' + _this6.month + '/' + _this6.day !== currentDate) {
          return;
        }

        _this6.dayPreRes = res;
      }).catch(function (err) {
        _this6.isloading = false; // 接口报错，前一天数据置空，防止数据一直取上一次成功时候的接口，导致显示数据不正确

        _this6.dayPreRes = [];

        if (err.code === "ECONNABORTED") {
          _this6.noNet = true;
        }
      });
    },
    // 请求周报数据
    queryWeekData: function queryWeekData() {
      var _this7 = this;

      this.isloading = true;

      var _ref5 = this.$route.params || {},
          dayYear = _ref5.year,
          dayMonth = _ref5.month,
          dayDay = _ref5.day;

      console.log('请求周报数据================》》》》', dayYear);
      getSleepWeekReport({}, {
        dayYear: dayYear,
        dayMonth: dayMonth,
        dayDay: dayDay
      }).then(function (res) {
        // console.log('getSleepWeekReport', res)
        // 日期切换后，之前请求的数据弃用
        if (+_this7.year !== +dayYear || +_this7.month !== +dayMonth || +_this7.day !== +dayDay) {
          return;
        }

        _this7.weekRes = res;
        _this7.isloading = false;

        _this7.$nextTick(function () {
          //console.log(this.mode,this.$refs )
          _this7.mode === 'week' && _this7.$refs.weekly && _this7.$refs.weekly.changeRes(res);
          _this7.mode === 'day' && _this7.$refs.daily && _this7.$refs.daily.changeWeekRes(res);
          _this7.mode === 'day' && _this7.$refs.daily && _this7.$refs.daily.changeRes(_this7.dayRes);
          _this7.mode === 'day' && _this7.$refs.daily && _this7.$refs.daily.changePreRes(_this7.dayPreRes);
        });
      }).catch(function (err) {
        _this7.isloading = false;

        if (err.code === "ECONNABORTED") {
          _this7.noNet = true;
        }
      });
    },
    // 请求上一周周报数据
    queryPreWeekData: function queryPreWeekData() {
      var _this8 = this;

      var _ref6 = this.$route.params || {},
          year = _ref6.year,
          month = _ref6.month,
          day = _ref6.day;

      year = year || moment().year();
      month = month || moment().month() + 1;
      day = day || moment().date();
      var currentDate = year + '/' + month + '/' + day;
      var previewDate = moment(currentDate).subtract(1, 'weeks').format('YYYY-MM-DD');
      var previewYear = moment(previewDate).format('YYYY');
      var previewMonth = moment(previewDate).format('MM');
      var previewDay = moment(previewDate).format('DD'); // console.log('上一周',currentDate,this.$route.params, previewDate, previewYear, previewMonth, previewDay)

      getSleepWeekReport({
        year: previewYear,
        month: previewMonth,
        week: previewDay
      }, {
        dayYear: previewYear,
        dayMonth: previewMonth,
        dayDay: previewDay
      }).then(function (res) {
        // console.log('上一周周报数据', res)
        // 日期切换后，之前请求的数据弃用
        if (+_this8.year !== +year || +_this8.month !== +month || +_this8.day !== +day) {
          return;
        }

        _this8.weekPreRes = res;

        _this8.$nextTick(function () {});
      });
    },
    // 请求月报数据
    queryMonthData: function queryMonthData(year, month) {
      var _this9 = this;

      this.isloading = true;
      getSleepMonthReport({
        year: year,
        month: month
      }).then(function (res) {
        // console.log('getSleepMonthReport', res)
        // 日期切换后，之前请求的数据弃用
        if (+_this9.year !== +year || +_this9.month !== +month) {
          return;
        }

        _this9.monthRes = res;
        _this9.isloading = false;

        _this9.$nextTick(function () {
          _this9.$refs.monthly && _this9.$refs.monthly.changeRes(res);
        });
      }).catch(function (err) {
        _this9.isloading = false;

        if (err.code === "ECONNABORTED") {
          _this9.noNet = true;
        }
      });
    },
    // 请求上一个月月报数据
    queryPreMonthData: function queryPreMonthData() {
      var _this10 = this;

      var currentDate = this.year + '/' + this.month + '/01';
      var previewDate = moment(currentDate).subtract(1, 'months').format('YYYY-MM-DD');
      var previewYear = moment(previewDate).format('YYYY');
      var previewMonth = moment(previewDate).format('MM');
      getSleepMonthReport({
        year: previewYear,
        month: previewMonth
      }).then(function (res) {
        // console.log('上一个月数据', res)
        // 日期切换后，之前请求的数据弃用
        if (_this10.year + '/' + _this10.month + '/01' !== currentDate) {
          return;
        }

        _this10.monthPreRes = res;

        _this10.$nextTick(function () {});
      });
    },
    // 请求是否为会员
    queryIsVip: function queryIsVip() {
      var _this11 = this;

      getVipFlag().then(function (res) {
        // console.log('getVipFlag', res)
        _this11.isVip = res.vipFlag === 1;
      }).catch(function (err) {
        if (err.code === "ECONNABORTED") {
          _this11.noNet = true;
        }
      });
    },
    // 刷新数据
    refreshData: function refreshData() {
      this.getDateByRoute(this.$route);
    }
  }
};